import type { LoadingTextProps } from "@naf/teamscheme";
import styled from "styled-components";
import LoadingBox from "../LoadingBox";
import { NoPreviewFlowHeader } from "../layout/header/FlowHeader";
import StaticPage from "../static-pages/StaticPage";

const StyledLoadingBox = styled(LoadingBox)`
  padding: ${({ theme }) => theme.spacing.space16};
`;

export function StaticLoadingScreen(props: LoadingTextProps) {
  return (
    <StaticPage>
      <StyledLoadingBox {...props} />
    </StaticPage>
  );
}

export function LoadingFlowScreen(props: LoadingTextProps) {
  return (
    <>
      <NoPreviewFlowHeader />
      <StyledLoadingBox {...props} />
    </>
  );
}
